(() => {
  document.querySelectorAll('[data-discount-ends-at]').forEach((notice) => {
    if (notice.dataset.countdownReady) return;
    const deadline = Date.parse(notice.dataset.discountEndsAt);
    if (!Number.isFinite(deadline)) { notice.hidden = true; return; }
    notice.dataset.countdownReady = 'true';
    const start = Date.parse(notice.dataset.discountStartsAt);
    const clock = notice.querySelector('[data-presale-clock]');
    const heading = notice.querySelector('h3');
    const note = notice.querySelector('.presale-countdown__note');
    const update = () => {
      const seconds = Math.max(0, Math.ceil((deadline - Math.max(Date.now(), Number.isFinite(start) ? start : 0)) / 1000));
      if (seconds === 0) {
        heading.textContent = 'This discount has ended';
        if (note) note.hidden = true;
        clock.textContent = 'The discount period is over.';
      } else {
        const days = Math.floor(seconds / 86400);
        const hours = Math.floor(seconds % 86400 / 3600);
        const minutes = Math.floor(seconds % 3600 / 60);
        clock.textContent = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds % 60).padStart(2, '0')}s`;
      }
      clock.hidden = false;
      return seconds;
    };
    if (update() > 0) {
      const timer = setInterval(() => { if (update() === 0) clearInterval(timer); }, 1000);
    }
  });
})();
